// @flow

import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { If } from '@presentational/If';
import { PrimaryButton } from '@presentational/buttons/PrimaryButton';
import {
  getErrorStatusAndDetailFromErrorObject,
  toastError,
  toastSuccess,
} from '@presentational/notifications/utils';
import { DEFAULT_FE_ERROR_MESSAGE } from '@src/constants';

import { EstimateContext } from '../../contexts/EstimateContext';
import { getIfQuoteLineIdIsProvided } from '../../common-utils/utils';
import { useUploadDataToSFDCMutation } from '../../service-definitions/estimates';

export const PushToSFDCButton = ({ disabledFromParent }) => {
  const { estimateId } = useParams();
  const estimateData = useContext(EstimateContext);
  const [uploadDataToSFDCFunc] = useUploadDataToSFDCMutation();
  const isQuoteLineIdProvided = getIfQuoteLineIdIsProvided(estimateData?.inputs);

  const handlePushToSFDC = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { error } = await uploadDataToSFDCFunc({
      estimateId,
    });
    if (error) {
      const { errorStatus, errorDetail } = getErrorStatusAndDetailFromErrorObject(error);
      let content = DEFAULT_FE_ERROR_MESSAGE;
      if (errorStatus === 404 || errorStatus === 403) {
        content = errorDetail;
      }
      toastError(error, content);
    } else {
      toastSuccess('Successfully uploaded the data to SFDC!!');
    }
  };

  return (
    <If test={isQuoteLineIdProvided}>
      <PrimaryButton
        circular={true}
        compact={true}
        disabled={disabledFromParent}
        onClick={handlePushToSFDC}
        size="mini"
        text="Push To SFDC"
      />
    </If>
  );
};
